import { CircularProgress, DialogActions, makeStyles } from '@material-ui/core';
import Button from './button';
import ModalV2 from './modal-v2';
import Text from './text';

const useStyles = makeStyles({
  actions: {
    padding: '30px 0 0',
  },
});

interface SessionConflictModalProps {
  open: boolean;
  isLoading?: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export function SessionConflictModal({
  open,
  isLoading,
  onSubmit,
  onClose,
}: SessionConflictModalProps) {
  const classes = useStyles();

  return (
    <ModalV2
      width='480px'
      open={open}
      onClose={onClose}
      titleProps={{ title: 'Conflicting Session' }}>
      <Text variant='normal'>
        A session has already been scheduled for the same date/time.
      </Text>
      <DialogActions className={classes.actions}>
        <Button
          variant='outlined'
          onClick={onClose}
          type='button'
          data-testid='button-cancel'>
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={isLoading}
          type='button'
          data-testid='button-success'>
          {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Save'}
        </Button>
      </DialogActions>
    </ModalV2>
  );
}
